import { useCallback, useEffect, useState } from "react";
import { get } from "../../modules/server";
import { logAndNotifyError } from "../../modules/logger";
import { useNavigate } from "react-router-dom";
import { post } from "../../modules/server";
import Notify from "devextreme/ui/notify";

import { DTORound } from "../../types/building";
import { Button, Table } from "react-bootstrap";
import { RoundStatus, useRound } from "../../modules/roundHandler";
import { useGlobalData } from "../GlobalDataProvider";
import notify from "devextreme/ui/notify";
import { UserInfo } from "../../types/user-info";
import ToolTipBox from "../Global/Editors/ToolTipBox";
import { nameof } from "../Global/Utils";
import { MapTooltip } from "../../types/globalData";
import { showPDFFromBase64 } from "../../modules/common";

interface IProps {
  buildingId: number;
  // onStart: () => void;
  // onResume: () => void;
  // onCancel: () => void;
  user: UserInfo;
}

const BuildingRoundList = ({ buildingId, user }: IProps) => {
  const [rounds, setRounds] = useState<any[] | undefined>(undefined);
  const [roundIdToConfirmDelete, setRoundIdToConfirmDelete] = useState<number | undefined>(undefined);
  const [roundIdToConfirmUpdateConfig, setRoundIdToConfirmUpdateConfig] = useState<number | undefined>(undefined);
  const roundHandler = useRound();
  const navigate = useNavigate();
  const globalData = useGlobalData();
  const isDebug = globalData.isDebug;

  const refreshRounds = useCallback(async () => {
    const res = await get("GetBuildingRounds/" + buildingId);
    if (!res) {
      const dbg = 5;
      logAndNotifyError("Ronderingar kunde inte hämtas : " + buildingId);
    }
    if (res?.rounds) {
      setRounds(res?.rounds);
    }
  }, [buildingId]);

  useEffect(() => {
    (async () => {
      refreshRounds();
    })();
  }, [refreshRounds]);

  const showPDF = async (roundId: number) => {
    const res = await post("GetPDFReport", { roundId: roundId });
    if (res?.succeeded) {
      showPDFFromBase64(res.pdf);
    } else {
      Notify(res?.message, "error");
    }
  };

  const deleteRound = (r: DTORound) => {
    setRoundIdToConfirmDelete(r.id);
  };

  const confirmedDeleteRound = async (r: DTORound) => {
    const res = await post("DeleteRound/" + r.id, {});
    if (res.succeeded) {
      Notify("Ronderingen borttagen");
    } else logAndNotifyError("Ronderingen kunde inte tas bort : " + res.messsage);

    refreshRounds();
  };

  const updateConfig = async (round: DTORound) => {
    setRoundIdToConfirmUpdateConfig(round.id);
  };

  const confirmedUpdateConfig = async (round: DTORound) => {
    const building = buildingId ? globalData.buildings?.find((b) => b.id === buildingId) : undefined;
    if (building) {
      const updatedRound = await roundHandler.updateRoundConfig(round, building);
      const dbg = updatedRound;
      setRoundIdToConfirmUpdateConfig(undefined);
      if (updatedRound) refreshRounds();
    }
  };

  const markAsDraft = async (r: DTORound) => {
    const res = await post("MakeRoundDraft/" + r.id, {});
    if (res.succeeded) {
      Notify("Ronderingen har återgått till utkast");
    } else logAndNotifyError("Ronderingen kunde inte sättas till utkast : " + res.messsage);

    refreshRounds();
  };

  const resumeRound = async (round: DTORound) => {
    const existingRound = await roundHandler.resumeRound(round);

    if (existingRound) {
      if (existingRound.status === RoundStatus.Finished) notify("Ronderingen öppnas - Inga ändringar kommer att sparas!");
      navigate("/round/" + existingRound.id + "/0");
    }
  };

  return (
    <div>
      {rounds ? (
        <Table className="m-0" striped bordered hover>
          <>
            <thead>
              <tr>
                <th>Datum</th>
                <th>Typ</th>
                {isDebug && <th>Namn(Dbg)</th>}
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rounds.map((r: DTORound) => (
                <tr key={r.id}>
                  <td>{new Date(r.date).toLocaleDateString("sv-SE")}</td>
                  <td>{r.isSummer ? "Sommar" : "Vinter"}</td>
                  {isDebug && <td>{r.name}</td>}
                  <td>{r.status === RoundStatus.Draft ? "Utkast" : "Avslutad"}</td>
                  <td style={{ textAlign: "right", width: 420 }}>
                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                      {r.status === RoundStatus.Finished && user.roles.Admin && (
                        <ToolTipBox tooltipId={nameof<MapTooltip>("BTN_TillUtkast")}>
                          <Button variant="outline-info" onClick={() => markAsDraft(r)}>
                            {" => utkast"}
                          </Button>
                        </ToolTipBox>
                      )}
                      {r.status === RoundStatus.Finished && (
                        <ToolTipBox tooltipId={nameof<MapTooltip>("BTN_ShowPDF")}>
                          <Button onClick={() => showPDF(r.id)}>PDF</Button>
                        </ToolTipBox>
                      )}

                      {r.status === RoundStatus.Draft ? (
                        <>
                          {r.id === roundIdToConfirmDelete ? (
                            <>
                              <Button variant="danger" onClick={() => confirmedDeleteRound(r)}>
                                Bekräfta borttag
                              </Button>
                              <Button variant="secondary" onClick={() => setRoundIdToConfirmDelete(undefined)}>
                                Avbryt
                              </Button>
                            </>
                          ) : r.id === roundIdToConfirmUpdateConfig ? (
                            <>
                              <Button variant="secondary" onClick={() => setRoundIdToConfirmUpdateConfig(undefined)}>
                                Avbryt
                              </Button>
                              <Button variant="danger" onClick={() => confirmedUpdateConfig(r)}>
                                Bekräfta uppdatera konfig
                              </Button>
                            </>
                          ) : (
                            <>
                              {user.roles.Round && (
                                <Button variant="outline-info" onClick={() => updateConfig(r)}>
                                  Uppdatera konfig
                                </Button>
                              )}
                              {user.roles.Round && (
                                <>
                                  <ToolTipBox tooltipId={nameof<MapTooltip>("BTN_ÅterupptaRondering")}>
                                    <Button onClick={() => resumeRound(r)}>Återuppta</Button>
                                  </ToolTipBox>
                                  <Button variant="danger" onClick={() => deleteRound(r)}>
                                    Ta bort
                                  </Button>
                                </>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {user.roles.Round && (
                            <>
                              <ToolTipBox tooltipId={nameof<MapTooltip>("BTN_ÖppnaRondering")}>
                                <Button onClick={() => resumeRound(r)}>Öppna</Button>
                              </ToolTipBox>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </>
        </Table>
      ) : (
        <>
          <h4>Laddar...</h4>
        </>
      )}
    </div>
  );
};

export default BuildingRoundList;
